import { render, staticRenderFns } from "./fba.vue?vue&type=template&id=0813806e&scoped=true&"
import script from "./fba.vue?vue&type=script&lang=js&"
export * from "./fba.vue?vue&type=script&lang=js&"
import style0 from "./fba.vue?vue&type=style&index=0&id=0813806e&prod&scoped=true&lang=scss&"
import style1 from "./fba.vue?vue&type=style&index=1&id=0813806e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0813806e",
  null
  
)

export default component.exports